import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { IdentityService } from '../authentication/identity.service';
import { NotificationsService } from '../notifications/notifications.service';
import {
  CreateUpdateFlightAPICommand,
  ICreateUpdateFlightAPIParameters
} from './command/createUpdateFlightAPI.command';

@Injectable()
export class FlightsService {
  private titleMessage = 'toast.integrations.title';

  constructor(
    private _connectionService: ConnectionServices,
    private _identityService: IdentityService,
    private _notificationsService: NotificationsService
  ) {}

  public createUpdateFlightAPI(enabled: boolean): Observable<boolean> {
    const command = new CreateUpdateFlightAPICommand();
    command.setParameters(<ICreateUpdateFlightAPIParameters>{
      carrierAccountId: parseInt(this._identityService.userId),
      contractorAccountId: null,
      applicationName: 'AVIATION',
      description: 'AVIATION API Integration',
      userName: 'aviation123',
      password: 'aviation123',
      enabled,
      blocked: false
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }
}
